
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.5 23H1V.5a.5.5 0 00-1 0v23a.5.5 0 00.5.5h23a.5.5 0 000-1z"}}),_c('path',{attrs:{"d":"M24 10.42v-.04a.5.5 0 00-.11-.17.5.5 0 00-.37-.14l-4.73.21a.5.5 0 00.05 1l3.43-.15-9.09 9.08a.5.5 0 00.7.71l9.1-9.09-.16 3.43a.5.5 0 00.47.52h.03a.5.5 0 00.5-.47l.22-4.72v-.01a.51.51 0 00-.03-.16zM3 15a.5.5 0 00.34-.14l6.13-5.74 6.6 1.65a.5.5 0 00.51-.2L22.4 2.8a.5.5 0 00-.8-.6l-5.62 7.51-6.53-1.63a.5.5 0 00-.46.13l-6.33 5.92A.5.5 0 003 15z"}})])
          )
        }
      }
    